import * as getters from '@/store/modules/payments/batchfile/newPayment/getters'
import * as mutations from '@/store/modules/payments/batchfile/newPayment/mutations'
import * as actions from '@/store/modules/payments/batchfile/newPayment/actions'

const state = {
    accountsBalances: [],
    batchfileTransferList: [],
    batchfileTransferListHasMore: null,
    favoritesList: [],
    favoritesHasMore: null,
    batchfileFileTypeList: [],
    operationTypes: [],
    batchfileTransferTypeList: [],
    batchfileCategoriesList: [],
    batchfileMotivesList: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
